export default "__VITE_ASSET__BWlyMn36__"